module.exports = __webpack_public_path__ + "img/1.d00418a6.jpg";